/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './appointment-episode.reducer';

export const AppointmentEpisodeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const appointmentEpisodeEntity = useAppSelector(state => state.appointmentEpisode.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="appointmentEpisodeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.appointmentEpisode.detail.title">AppointmentEpisode</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.appointmentEpisode.id">Id</Translate>
            </span>
          </dt>
          <dd>{appointmentEpisodeEntity.id}</dd>
          <dt>
            <span id="expectedStartTime">
              <Translate contentKey="tinyMedicRestApp.appointmentEpisode.expectedStartTime">Expected Start Time</Translate>
            </span>
          </dt>
          <dd>{appointmentEpisodeEntity.expectedStartTime}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.appointmentEpisode.active">Active</Translate>
            </span>
          </dt>
          <dd>{appointmentEpisodeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.appointmentEpisode.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{appointmentEpisodeEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.appointmentEpisode.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{appointmentEpisodeEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.appointmentEpisode.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{appointmentEpisodeEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.appointmentEpisode.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{appointmentEpisodeEntity.timestampentry}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.appointmentEpisode.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{appointmentEpisodeEntity.notes}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.appointmentEpisode.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{appointmentEpisodeEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.appointmentEpisode.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{appointmentEpisodeEntity.modifiedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.appointmentEpisode.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{appointmentEpisodeEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.appointmentEpisode.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{appointmentEpisodeEntity.modifiedByType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.appointmentEpisode.appointment">Appointment</Translate>
          </dt>
          <dd>{appointmentEpisodeEntity.appointment ? appointmentEpisodeEntity.appointment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.appointmentEpisode.episode">Episode</Translate>
          </dt>
          <dd>{appointmentEpisodeEntity.episode ? appointmentEpisodeEntity.episode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.appointmentEpisode.hospital">Hospital</Translate>
          </dt>
          <dd>{appointmentEpisodeEntity.hospital ? appointmentEpisodeEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/appointment-episode" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/appointment-episode/${appointmentEpisodeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AppointmentEpisodeDetail;
